module.exports = __webpack_public_path__ + "static/media/pic-4.a5f06409.jpg";